// DORMANT: hosted-provider skill PUSH (upload a SKILL.md to an external hosted
// skills API, e.g. Anthropic). Disabled here (no UI trace) and 404'd server-side
// (settings.skills_hosted_push_enabled) — outbound skill-content egress cuts
// against the air-gap posture and "Push" confused tenants with "Publish".
//
// Extracted to its own module so the retained-but-dormant UI stays testable:
// a test can `vi.mock` this to `true` to exercise the push button + hosted
// section (proving they still render for the resurrection path) without
// shipping the feature. Flip this to true AND the backend flag
// (settings.skills_hosted_push_enabled) to actually resurrect. See CLAUDE.md
// "Dormant / disabled features".
export const HOSTED_PUSH_ENABLED = false;
